import { type ReactNode, createContext, useContext, useState } from 'react';

type SectionsDrawerContext = {
  isSectionsDrawerOpen: boolean;
  setIsSectionsDrawerOpen: (isSectionsDrawerOpen: boolean) => void;
};

const SectionsDrawerContext = createContext<SectionsDrawerContext | null>(null);

export const useSectionsDrawer = () => {
  const context = useContext(SectionsDrawerContext);

  if (!context) {
    return {
      isSectionsDrawerOpen: false,
      setIsSectionsDrawerOpen: () => {
        // do nothing
      },
    };
  }

  return context;
};

export const SectionsDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isSectionsDrawerOpen, setIsSectionsDrawerOpen] = useState(false);

  return (
    <SectionsDrawerContext.Provider value={{ isSectionsDrawerOpen, setIsSectionsDrawerOpen }}>{children}</SectionsDrawerContext.Provider>
  );
};
